<template>
<div class="chapter">
<div class="inner_page">
<p class="ded" id="toc"><b>Table of Contents</b></p>
<p class="center">___________________</p>
<p class="toc"><a href="#/Text/intro">Introduction</a></p>
<p class="toc"><a href="#/Text/part1">PART I: OUT OF THE PAST</a></p>
<p class="toc1"><a href="#/Text/chap1">Welcome to Amsterdam</a></p>
<p class="toc2">Michael Berg</p>
<p class="toc3">Schiphol Airport</p>
<p class="toc1"><a href="#/Text/chap2">Spui 13</a></p>
<p class="toc2">Anneloes Timmerije</p>
<p class="toc3">Centrum</p>
<p class="toc1"><span href="#/Text/chap3" title="Link target outside of Sample">Ankle Monitor</span></p>
<p class="toc2">Herman Koch</p>
<p class="toc3">Watergraafsmeer</p>
<p class="toc1"><span href="#/Text/chap4" title="Link target outside of Sample">Salvation</span></p>
<p class="toc2">A. Simon de Waal</p>
<p class="toc3">Red-Light District</p>
<p class="toc"><span href="#/Text/part2" title="Link target outside of Sample">PART II: KISS ME DEADLY</span></p>
<p class="toc1"><span href="#/Text/chap5" title="Link target outside of Sample">The Tower</span></p>
<p class="toc2">Hanna Bervoets</p>
<p class="toc3">Van der Pekbuurt</p>
<p class="toc1"><span href="#/Text/chap6" title="Link target outside of Sample">Silent Days</span></p>
<p class="toc2">Karin Amatmoekrim</p>
<p class="toc3">Oosterpark</p>
<p class="toc1"><span href="#/Text/chap7" title="Link target outside of Sample">Soul Mates</span></p>
<p class="toc2">Christine Otten</p>
<p class="toc3">Tuindorp Oostzaan</p>
<p class="toc"><span href="#/Text/part3" title="Link target outside of Sample">PART III: TOUCH OF EVIL</span></p>
<p class="toc1"><span href="#/Text/chap8" title="Link target outside of Sample">Devil’s Island</span></p>
<p class="toc2">Mensje van Keulen</p>
<p class="toc3">Duivelseiland</p>
<p class="toc1"><span href="#/Text/chap9" title="Link target outside of Sample">The Man on the Jetty</span></p>
<p class="toc2">Murat Isik</p>
<p class="toc3">Bijlmer</p>
<p class="toc1"><span href="#/Text/chap10" title="Link target outside of Sample">Lucky Sevens</span></p>
<p class="toc2">Theo Capel</p>
<p class="toc3">De Jordaan</p>
<p class="toc1"><span href="#/Text/chap11" title="Link target outside of Sample">The Stranger Inside Me</span></p>
<p class="toc2">Loes den Hollander</p>
<p class="toc3">Central Station</p>
<p class="toc"><span href="#/Text/part4" title="Link target outside of Sample">PART IV: THEY LIVE BY NIGHT</span></p>
<p class="toc1"><span href="#/Text/chap12" title="Link target outside of Sample">Seven Bridges</span></p>
<p class="toc2">Max van Olden</p>
<p class="toc3">Grachtengordel</p>
<p class="toc1"><span href="#/Text/chap13" title="Link target outside of Sample">The Girl at the End of the Line</span></p>
<p class="toc2">Abdelkader Benali</p>
<p class="toc3">Sloten</p>
<p class="toc1"><span href="#/Text/chap14" title="Link target outside of Sample">Get Rich Quick</span></p>
<p class="toc2">Walter van den Berg</p>
<p class="toc3">Osdorp</p>
<p class="toc1"><span href="#/Text/chap15" title="Link target outside of Sample">Starry, Starry Night</span></p>
<p class="toc2">René Appel &amp; Josh Pachter</p>
<p class="toc3">Museum District</p>
<p class="toc1"><span href="#/Text/bio" title="Link target outside of Sample">About the Contributors</span></p>
<p class="toc1"><span href="#/Text/extra" title="Link target outside of Sample">Bonus Materials</span></p>
<p class="toc2"><span href="#/Text/usanoir" title="Link target outside of Sample">Excerpt from <i>USA NOIR</i> edited by Johnny Temple</span></p>
<p class="toc2"><span href="#/Text/noir" title="Link target outside of Sample">Also in Akashic Noir Series</span></p>
<p class="toc2"><span href="#/Text/award" title="Link target outside of Sample">Akashic Noir Series Awards &amp; Recognition</span></p>
<p class="toc1"><span href="#/Text/akb" title="Link target outside of Sample">About Akashic Books</span></p>
<p class="toc1"><span href="#/Text/copy" title="Link target outside of Sample">Copyrights &amp; Credits</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?dfeac90e